export const dataLayer = (event, data) => {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({ event: event, ...data });
};
